import React, { useState, createContext, useContext } from "react";
import { getAllContentReports } from "../../GeneralAdmin/modules/GAContentModeration/hooks/ContentReportsHooks";
import { getSingleUser } from "../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";

export const ContentModerationContext = createContext();
export const useContentModerationContext = () =>
  useContext(ContentModerationContext);

export const ContentModerationProvider = ({ children }) => {
  // states
  const [loading, setLoading] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [selected, setSelected] = useState([]);
  const [allContentReports, setAllContentReports] = useState([]);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);

  //General Admin functions
  const handleGetContentReports = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getAllContentReports();
      const reportsPromises = querySnapshot.docs.map(async (item) => {
        const userTemp = await getSingleUser(item.data().reportedBy);
        return {
          ...item.data(),
          id: item.id,
          reportedByData: userTemp?.data() ? userTemp.data() : {},
        };
      });

      const contentReports = await Promise.all(reportsPromises);

      console.log("reports:", contentReports);

      setAllContentReports(contentReports);
      console.log("all Content Reports:", contentReports);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
    } finally {
      setLoading(false);
    }
  };
  //General Admin functions

  return (
    <ContentModerationContext.Provider
      value={{
        allContentReports,
        setAllContentReports,
        loading,
        setLoading,
        filterModal,
        setFilterModal,
        selected,
        setSelected,
        handleGetContentReports,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
      }}
    >
      {children}
    </ContentModerationContext.Provider>
  );
};
